import script from "./ReceiptBetslip.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptBetslip.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptBetslip.vue?vue&type=style&index=0&id=41df57dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41df57dd"]])

export default __exports__